import * as React from "react";
const SvgFiRrGlassChampagne = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 22h-3v-3.091c3.388-.487 6-3.416 5.996-7.019l-.834-9.162A2.986 2.986 0 0 0 15.174 0H8.826a2.986 2.986 0 0 0-2.988 2.728L5 11.981c0 3.52 2.612 6.442 6 6.928V22H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2M8.826 2h6.348c.521 0 .949.391.996.91L16.361 5H7.64l.19-2.09A.995.995 0 0 1 8.826 2m-1.83 10.072L7.458 7h9.086L17 11.981c0 2.757-2.243 5-5 5s-5-2.243-5.004-4.909"
    />
  </svg>
);
export default SvgFiRrGlassChampagne;
